/* global axios */

import ApiClient from './ApiClient';

class CatalogProductSetsAPI extends ApiClient {
  constructor() {
    super('catalog/product_sets', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  show(id, page = 1) {
    return axios.get(`${this.url}/${id}`, { params: { page } });
  }

  create(payload, productIds) {
    return axios.post(this.url, {
      product_set: { ...payload, product_ids: productIds },
    });
  }

  update(id, payload, productIds) {
    return axios.patch(`${this.url}/${id}`, {
      product_set: { ...payload, product_ids: productIds },
    });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  preview(filters, page = 1) {
    return axios.post(`${this.url}/preview`, { filters, page });
  }
}

export default new CatalogProductSetsAPI();
